import { render, staticRenderFns } from "./DaccountList.vue?vue&type=template&id=2097d9d6&scoped=true&"
import script from "./DaccountList.vue?vue&type=script&lang=js&"
export * from "./DaccountList.vue?vue&type=script&lang=js&"
import style0 from "./DaccountList.vue?vue&type=style&index=0&id=2097d9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2097d9d6",
  null
  
)

export default component.exports